module.exports = __webpack_public_path__ + "static/media/not-found.787a012a.png";